<template> 

  <div class="container pt-4 mb-5">
     
    <div>
      
      <b-row align-v="center">

        <b-col lg="12">
 
          <div class="mt-4">

            <div class="mt-3">

              <label>Wklej swój prompt:</label>

              <b-input-group>

                <b-form-textarea v-model="temat" size="lg" ref="temat" placeholder="np. napisz wiersz o wiośnie"></b-form-textarea>
                
              </b-input-group>
 
            </div>

          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje wynik <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowana treść</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;">

              <div v-if="result" v-html="result" class="pb-3 mb-3" style="border-bottom: 1px solid #ddd;"></div>

            </div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
   
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>
 
    </div>

  </div>

</template>

<script>

  import { languages } from './../../../resources/languages.js';

  export default {
    name: 'AppArticleSEOIdeas',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        result2: "",
        selectedText: '',
        query: "",
        lang: "Polski",
        languages,
        temat: "",
        finishContent: '',
        selectedSchema: null
      }
    },
    methods: {

      generateFinish: function() {

        if(!this.temat) return false;

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

        var query = "Jesteś Prompt Hero AI — najlepszym na świecie ekspertem w projektowaniu i optymalizacji promptów do ChatGPT i innych modeli językowych."+
                    "Twoim zadaniem jest analizowanie promptu użytkownika i tworzenie jego ulepszonej wersji, tak aby:"+
                    "•	Był bardziej precyzyjny,"+
                    "•	Wywoływał głębsze i bardziej użyteczne odpowiedzi,"+
                    "•	Miał klarowną strukturę i kontekst,"+
                    "•	Był dostosowany do celu użytkownika (np. marketing, edukacja, kodowanie, analiza, styl konwersacyjny itp.),"+
                    "•	Zawierał rolę, ton i oczekiwany format odpowiedzi,"+
                    "•	Używał języka modelu (np. “Jesteś ekspertem w...”) oraz jasnych instrukcji krok po kroku,"+
                    "•	Opcjonalnie zawierał dodatkowe pytania do doprecyzowania celu."+
                    "Kiedy użytkownik poda prompt, wykonaj następujące kroki:"+
                    "🔹 ETAP 1: ANALIZA"+
                    "1.	Zrozum dokładnie, co użytkownik chce osiągnąć."+
                    "2.	Zidentyfikuj braki, niejasności lub zbyt ogólne fragmenty."+
                    "3.	Ustal cel, ton, kontekst, odbiorcę i pożądany format odpowiedzi."+
                    "🔹 ETAP 2: POPRAWA PROMPTU"+
                    "Stwórz ulepszoną wersję promptu, która:"+
                    "•	Jest jasna, precyzyjna i inspirująca dla modelu AI,"+
                    "•	Zawiera rolę "+
                    "•	Określa cel i oczekiwany efekt,"+
                    "•	Zawiera konkretne polecenia (np. „podaj 10 przykładów”, „napisz w tonie motywującym”, „użyj punktów i emoji”),"+
                    "•	Opcjonalnie dodaje parametry stylu („pisz jak Gary Halbert”, „styl Tony’ego Robbinsa”, „użyj storytellingu”)."+
                    " ETAP 3: WYJŚCIE"+
                    "Odpowiedź powinna zawierać:"+
                    "Ulepszoną wersję promptu (gotowy do użycia):"+
                    "– gotowy tekst, który użytkownik może skopiować i wkleić do ChatGPT."+
                    "Oto prompt użytkownika " + this.temat;

   

        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/><br/>');


          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana treść"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Treść została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {


 
    },
    mounted() {

      if (localStorage.generators_language) {

        this.lang = localStorage.generators_language;

      } else {

        localStorage.generators_language = "Polski"
        this.lang = "Polski"
      }

    },
    watch: {

      lang(data) {

        localStorage.generators_language = data;

      },

    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>